export interface DbEntry {
    id?: string;
    isPublished?: boolean;
    createdAt?: Date;
    modifiedAt?: Date;
}
